import Vue from 'vue';
import Vuex from 'vuex';

import { state, getters, actions, mutations } from './mutations';
import { mapStore } from './modules/map';
import { sprayPathStore } from './modules/spray-paths';
import { coordinateEditorStore } from './modules/coordinateEditor';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    map: mapStore,
    sprayPaths: sprayPathStore,
    coordinateEditor: coordinateEditorStore,
  },
});
